/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import React, { Component } from 'react';
import {
    Button,
    TextInput,
    Header,
    HeaderName,
    SkipToContent
} from "@carbon/react";
import { immutable_set } from "../../utils";
import { userService } from "../../services";
import { BlackFooter } from "../../components/common/footers/BlackFooter";
import { SupportContactInfo } from "../../components/common/SupportContactInfo";
import { TITLE_TRUSTED_ACCOUNT_PAGE } from "../../components/common/constants";
import { trackAuthScreenSubmit } from "../../utils/analytics-tracker-utils";

// Basic email shape check. The character classes are mutually exclusive (no '@' or whitespace
// inside them), so the expression is linear - there is nothing for the engine to backtrack over.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class TrustedAccountPagePresentation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emailValue: ''
        };
        this.updateEmailValue = this.updateEmailValue.bind(this);
        this.submitTrustedAccount = this.submitTrustedAccount.bind(this);
        document.title = TITLE_TRUSTED_ACCOUNT_PAGE;
    }

    updateEmailValue(evt) {
        const emailValue = evt.target.value;
        this.setState((prevState) => immutable_set(prevState, "emailValue", emailValue));
    }

    isEmailValid() {
        return EMAIL_REGEX.test(this.state.emailValue.trim());
    }

    submitTrustedAccount(evt) {
        if (evt) {
            evt.preventDefault();
        }
        if (!this.isEmailValid()) {
            return;
        }
        trackAuthScreenSubmit();
        // Top-level navigation to the proxy, which 302-redirects to Microsoft Entra with the
        // email forwarded as login_hint so the sign-in page is pre-filled.
        window.location.assign(userService.getEntraLoginUrl(this.state.emailValue.trim()));
    }

    render() {
        return (
            <div className="Login TrustedAccount">
                <Header aria-label="Merative Platform Name" className="chatbot-custom-header">
                    <SkipToContent />
                    <HeaderName href="#" prefix="Merative">
                        Micromedex&reg;
                    </HeaderName>
                </Header>
                <div className="mdx-scroll-area">
                    <div className="mdx-loginBannerImg">
                        <img size="small" src="images/micromedex-lead.png" alt="" className='login-image'/>
                    </div>
                    <div className="mdx-login-content">
                        <div className="mdx-left-content">
                            <div className="mdx-form-element">
                                <form onSubmit={this.submitTrustedAccount}>
                                    <TextInput
                                        id="trusted-account-email"
                                        className="trusted-account-email"
                                        labelText="Work email"
                                        type="email"
                                        autoComplete="email"
                                        value={this.state.emailValue}
                                        onChange={this.updateEmailValue}
                                        required
                                    />
                                    <Button
                                        id="trusted-account-submit"
                                        className="App trusted-account-submit"
                                        kind="primary"
                                        size="small"
                                        type="submit"
                                        disabled={!this.isEmailValid()}>
                                        Submit
                                    </Button>
                                </form>
                            </div>
                        </div>
                        <div className="mdx-right-content">
                            <SupportContactInfo />
                        </div>
                    </div>
                </div>
                <BlackFooter />
            </div>
        );
    }
}

export default TrustedAccountPagePresentation;



